import defineComponent from 'flight'

function Login() {
    this._showLogin = function (evt, evtData) {
        let destination = evtData && evtData.destination ?
            evtData.destination :
            encodeURIComponent(window.location.pathname) + encodeURIComponent(window.location.search);
        let url = '/login?ReturnUrl=' + destination;
        document.location.href = url;
    };

    this.after('initialize', function () {
        this.on(document, 'ui:login:show', this._showLogin);
    });
}

module.exports = defineComponent.component(Login);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/layout/login.js